module.exports = __webpack_public_path__ + "img/embed_code.6ce18376.png";